/**
 * Provider Authentication Form Component
 * Formulário dinâmico baseado nos authFields do provider
 */

import React from 'react';
import { Input } from '@/shared/components/ui/Input';
import type { DatabaseProvider } from '@/providers/database';

export interface ProviderAuthFormProps {
  /** Provider para exibir formulário de autenticação */
  provider: DatabaseProvider;
  /** Valores atuais das credenciais */
  credentials: Record<string, any>;
  /** Callback quando credenciais são alteradas */
  onCredentialsChange: (credentials: Record<string, any>) => void;
}

export const ProviderAuthForm: React.FC<ProviderAuthFormProps> = ({
  provider,
  credentials,
  onCredentialsChange,
}) => {
  const handleFieldChange = (fieldName: string, value: string) => {
    onCredentialsChange({
      ...credentials,
      [fieldName]: value,
    });
  };

  return (
    <div className="space-y-4">
      {provider.authFields.map((field) => (
        <div key={field.name}>
          <label
            className="block text-sm font-medium mb-2"
            style={{ color: '#1e293b' }}
          >
            {field.label}
          </label>
          {/* Input shared (NUNCA #9: nada de <input> nativo em modais) */}
          <Input
            type={field.type}
            placeholder={field.placeholder}
            value={credentials[field.name] || ''}
            onChange={(e) => handleFieldChange(field.name, e.target.value)}
            data-testid={`provider-auth-${field.name}`}
          />
          {field.helpText && (
            <p className="text-xs mt-2" style={{ color: '#64748b' }}>
              {field.helpText}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};
